<template>
    <div class="main-layout">
        <slot></slot>
    </div>
</template>

<style lang="scss" scoped>

</style>

<script>
    export default {

    };
</script>
